import { message } from "antd";
import { CommmonGet } from "./network/api";

export function formatDateString(dateStr) {
    var parts = dateStr.split("-");
    var formattedMonth = parts[1].length === 1 ? "0" + parts[1] : parts[1];
    var formattedDay = parts[2].length === 1 ? "0" + parts[2] : parts[2];
    return parts[0] + "-" + formattedMonth + "-" + formattedDay;
};
// 日期格式处理
export function formatDate(dateString: string, format: string): string {
    const date = new Date(dateString);
    const map: { [key: string]: string } = {
        "yyyy": date.getFullYear().toString(),
        "MM": ('0' + (date.getMonth() + 1)).slice(-2),
        "dd": ('0' + date.getDate()).slice(-2),
        "HH": ('0' + date.getHours()).slice(-2),
        "mm": ('0' + date.getMinutes()).slice(-2),
        "ss": ('0' + date.getSeconds()).slice(-2)
    };

    return format.replace(/yyyy|MM|dd|HH|mm|ss/gi, matched => map[matched]);
}
export function getAddress(sysID) {
    // let config = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_SYSTERM_ID}_config`) || "{}");
    return new Promise(function (resolve, reject) {
        let address = localStorage.getItem(`address${sysID}`);
        if (address) {
            resolve(JSON.parse(address));
        } else {
            CommmonGet(`/portal/common/getSubSystemsMainServerBySubjectID`, { sysId: sysID }).then((response: any) => {
                if (response.StatusCode === 200 && response.Data[0]) {
                    resolve(response.Data[0]);
                    localStorage.setItem(`address${sysID}`, JSON.stringify(response.Data[0]));
                } else {
                    throw new Error();
                }
            }).catch((error) => {
                reject('');
                localStorage.setItem(`address${sysID}`, '');
            });
        }
    })
}
// 宽度一半的类型
export const rowWidth50 = [1, 3, 4, 5, 7, 8];
export function getProduct() {
    return new Promise(async (resolve, reject) => {
        let productInfo: any = {} // JSON.parse(localStorage.getItem(`${process.env.REACT_APP_SYSTERM_ID}_product`) || "{}");
        if (!productInfo?.EduID) {
            // let config = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_SYSTERM_ID}_config`) || "{}");
            CommmonGet(`/portal/common/getBaseProductsInfo`,).then((response: any) => {
                if (response.ErrCode === 0) {
                    resolve(response.Data);
                    localStorage.setItem(`${process.env.REACT_APP_SYSTERM_ID}_product`, JSON.stringify(response.Data));
                }
            }).catch(() => {
                message.warning("获取用户信息失败，请重试", 2);
            });
        } else {
            resolve(productInfo);
        }
    });
}
export async function getPreUrl(file, type) {
    const product: any = await getProduct();
    const obj: any = await getAddress('U10');
    let url = type ? file.url : file.preUrl
    const win: any = window
    url += `${url.includes('?') ? '&' : '?'}encoded=true&fullfilename=${file.originalName}&resId=${file.md5Id || file.resId}&schoolId=${product.EduID}`;
    return `${obj.WebSvrAddr}onlinePreview?url=${encodeURIComponent(win?.Base64?.encode(url))}`;
}

// 预览
export const previewFile = (file: any) => {
    const url = file.preUrl || file.url;
    if (url) {
        const page = window.open(url);
        setTimeout(() => {
            const isPDF = url.endsWith('.pdf')
            const isImg = /(.jpg|.png|.gif|.jpeg)/.test(url)
            if (page.document) {
                if (isPDF) {
                    page.document.title = 'PDF预览'
                } else if (isImg) {
                    page.document.title = '图片预览'
                }
            }
        }, 1000)
    } else {
        message.destroy();
        //   message.loading('预览地址有误', 0);
        message.warning('预览地址有误');
    }
};

// export function previewFile(file, type?: any) {
//     getPreUrl(file, type).then((url) => {
//         window.open(url);
//     })
// }
export function downloadFile(url, fileName) {
    //下载文件不预览
    const link = document.createElement('a')
    return fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

export const CheckEmail = (value) => {
    let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    return !(value.length > 0 && reg.test(value) === false);
};

export function imageToDataUrl(src: string): Promise<string> {
    const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = src;
    img.setAttribute('crossOrigin', 'anonymous')
    return new Promise((resolve, reject) => {
        img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL())
        };
    })
}